/* eslint-disable import/prefer-default-export */

import { CategoryType } from 'src/graphql/generated/operations';

export const categoryIsPreorderable = (category: CategoryType): boolean =>
  category.preOrderTakeaway;
